import { Button, Snackbar, SnackbarContent } from '@material-ui/core';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import ErrorIcon from '@material-ui/icons/Cancel';
import SuccessIcon from '@material-ui/icons/CheckCircle';
import cx from 'classnames';
import { bool, func, number, object, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import constants from '../../helpers/constant';
import { hideToast } from '../../state/modules/app/notification';
import styles from './styles.scss';


const listColor = {
  [constants.FAILED]: '#ff0000',
  [constants.SUCCESS]: '#2196F3',
  [constants.WARNING]: '#FF5B28'
};

const listIcon = {
  [constants.SUCCESS]: <SuccessIcon style={{ color: '#28BA3F' }} />,
  [constants.FAILED]: <ErrorIcon style={{ color: listColor[constants.FAILED] }} />,
};

const customButton = type =>
  createTheme({
    overrides: {
      MuiButton: {
        root: {
          color: listColor[type]
        }
      }
    }
  });

@connect(
  state => ({
    toast: state.notification.toast
  }),
  dispatch => ({
    hideToast: compose(dispatch, hideToast)
  })
)
class ToastNotification extends Component {
  static propTypes = {
    hideToast: func,
    toast: shape({
      open: bool,
      position: object,
      message: string,
      action: string,
      autoHideDuration: number,
      type: string,
      isShowCustomizedToast: bool,
    })
  };
  handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.props.hideToast();
  };

  renderCustomizeToast = (label, message, type) => {
    return (
      <div className={cx(styles.toastContainer)}>
        <div className={cx(styles.borderLeft, styles[type.toLowerCase()])} />
        <div className={cx(styles.toastContent)}>
          <div className={cx(styles.typeIcon)}>
            {listIcon[type]}
          </div>
          <div className={styles.contentText}>
            {label && <span className={styles.typeText}>{label}: </span>}
            <span>{message}</span>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      open,
      position,
      message,
      action,
      autoHideDuration,
      type,
      isShowCustomizedToast,
      label
    } = this.props.toast;
    const actionToast = (
      <Button
        size="small"
        onClick={this.handleClose}
        style={{ color: listColor[type] }}
      >
        {action}
      </Button>
    );

    return (
      <div>
        <MuiThemeProvider theme={customButton(type)}>
          <Snackbar
            data-test="alertBox"
            anchorOrigin={position}
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={this.handleClose}
          >
            {isShowCustomizedToast ? (
              this.renderCustomizeToast(label, message, type)
            ) : (
              <SnackbarContent
                data-test="alertBoxContent"
                message={message}
                action={actionToast}
              />
            )}
          </Snackbar>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default ToastNotification;
